import { useEffect, useState } from 'react';

import { subscribe, accountOrdersQuery } from '@/lib/firestore';
import type { Order } from '@/schemas';

export type OrderWithId = Order & { id: string };

/** Live list of hardware orders for an account, newest first. Empty
 * array until at least one order exists. */
export function useOrders(aid: string | null): {
  orders: OrderWithId[];
  loading: boolean;
} {
  const [state, setState] = useState<{ loadedAid: string | null; data: OrderWithId[] }>({
    loadedAid: null,
    data: [],
  });
  useEffect(() => {
    if (!aid) {
      setState({ loadedAid: null, data: [] });
      return;
    }
    setState({ loadedAid: null, data: [] });
    const unsub = subscribe<Order>(accountOrdersQuery(aid), (rows) => {
      setState({ loadedAid: aid, data: rows });
    });
    return unsub;
  }, [aid]);
  return {
    orders: state.loadedAid === aid ? state.data : [],
    loading: aid != null && state.loadedAid !== aid,
  };
}
